<template>
    <div class="select-box" :style="{width: width+'px'}">
        <el-table ref="selectBox" :data="selectData" highlight-current-row @current-change="handleCurrentChange"
                style="width: 100%">
            <el-table-column v-for="(val, k) in fieldData" :prop="k" :label="val ? val : ''"
                             :min-width="k === 'no' ? 180: (k === 'mobile' ? 130 :100)"
            >
                <template slot-scope="data">
                    {{data.row[k] ? data.row[k] : "无"}}
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "PopSelect",
        data: () => ({
            selectValue: ""
        }),
        props: {
            fieldData: {
                type: Object,
                default: []
            },
            selectData: {
                type: Array,
                default: []
            },
            width: {
                type: Number,
                default: 0
            },
            height: {
                type: Number,
                default: 200
            }
        },
        // model: {
        //     prop: "selectValue",
        //     event: "change"
        // },
        mounted: function(){
            $(".select-box .el-table__body-wrapper").css("max-height", this.height + "px");
            obj.scrollbar(".select-box .el-table__body-wrapper");
        },
        methods: {
            handleCurrentChange(data) {
                if(typeof data != "undefined") {
                    this.$emit("select", data);
                    this.selectValue = data;
                }

                this.$refs["selectBox"].setCurrentRow();
            }
        }
    }
</script>

<style scoped>
    .select-box{
        position: absolute;
        background: #ffffff;
        box-shadow: 5px 0px 10px #dbdbdb;
        border: 1px solid #dddddd;
        z-index: 999;
        overflow: hidden;
    }
</style>
